import React from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";

// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Geolocalisation from "../pages/geolocalisation";
import Login from "../pages/login";

// context
import QrCode from "../pages/qrCode/QrCode";

export default function App() {
  // global
  // var { isAuthenticated } = useUserState();
  var isAuthenticated  = (localStorage.getItem("user") !== null && localStorage.getItem("user") !== undefined) ? true : false;
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/Solde/show" />} />
        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/Solde/show" />}
        />
        <Route path="/maps/:data/" component={Geolocalisation} />
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/QrCode/:data" component={QrCode} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
